export default "__VITE_ASSET__aa3dbdc1__"